import { createContext } from 'react';

interface AppConfigContextType {
  appConfig: Record<string, any>;
  saveAppConfig: (configId: string, dataToSave: Partial<Record<string, any>>) => Promise<boolean>;
  isFetchingConfig: boolean;
}

export const AppConfigContext = createContext<AppConfigContextType | null>(null);
